import React from "react"
import { grey50, grey900 } from "material-ui/styles/colors"
import * as timeHelper from "../../../helpers/timeHelper"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import { ISimpleTime } from "../../../models"
interface IProps {
    mousePositionX: number
    mousePositionY: number
    coordinateTime: ISimpleTime
    widthPerHour: number
    startTimePositionX: number
    endTimePositionX: number
}

const TimelineItemMoveTimeTitle: React.SFC<IProps> = (props: IProps) => {
    const schduleEditDialog = document.getElementsByClassName("ScheduleEditDialog")
    let diffX = 0
    let diffY = 0
    if (schduleEditDialog.length) {
        const dialogBox = schduleEditDialog[0].firstElementChild.firstElementChild.getBoundingClientRect()
        diffX = dialogBox.left
        diffY = dialogBox.top
    }

    return (
        <div
            style={{
                position: "fixed", padding: "2px 7px", backgroundColor: grey50, border: "1px solid grey", borderColor: grey900, fontSize: 12, zIndex: 999,
                left: props.mousePositionX + 10 - diffX,
                top: props.mousePositionY + 15 - diffY
            }}
        >
            {`${timeHelper.getTimeStringSimpleFormatFromSimpleTime(scheduleHelper.getSimpleTimeFromPositionX(props.coordinateTime, props.widthPerHour, props.startTimePositionX))}-${timeHelper.getTimeStringSimpleFormatFromSimpleTime(scheduleHelper.getSimpleTimeFromPositionX(props.coordinateTime, props.widthPerHour, props.endTimePositionX))}`}
        </div>
    )
}

export default TimelineItemMoveTimeTitle